import React from 'react'

export default class FengmapBaseControl extends React.Component {
  load = () => {}
  unload = () => {}
}
